function BasketPageClickEvents() {
    // #region BasketItems
    $(document).on("keyup", ".OrderBasketContainer .Quantity input.sepetAdet", function () {
        var basketID = $(this).attr("data-id");
        var Amount = $(this).val();
        var LangID = $("#LangID").val();

        if (Amount <= 1) {
            $(this).val(1);
            Amount = 1;
        }
        else if (Amount >= 9) {
            $(this).val(9);
            Amount = 9;
        }

        UpdateCartAmount(basketID, Amount, LangID);
    });


    $(document).on("click", ".OrderBasketContainer .Quantity .GenMinus, .OrderBasketContainer .Quantity .GenPlus", function () {
        AmountInput = $(this).parent().children(".sepetAdet");

        if ($(this).hasClass("GenPlus") == true) {
            AmountInput.val(parseInt(AmountInput.val()) + 1);
        }
        else {
            AmountInput.val(parseInt(AmountInput.val()) - 1);
        }

        if (AmountInput.val() > 0) {
            AmountInput.trigger('keyup');
        }
        else {
            AmountInput.parents(".SepetRow").find(".ItemDelete .RemoveIcon").trigger("click");
        }
    });

    $(document).on("click", ".MobileBasketDetailButton", function () {
        $(".MobileBasketDetails").toggleClass("d-flex");
    });

    $(document).on("click", ".OrderBasketContainer .SepetRow .ItemDelete .RemoveIcon", function () {
        var ItemID = $(this).attr("data-id");
        var LangID = $("#LangID").val();

        var UserID = $('#UserID').val();

        if (!UserID || UserID == "0")
            UserID = "unknown";

        var ProductName = $(this).attr("data-productname");

        var ProductQuantity = $(this).attr("data-quantity");

        var stockQuantity = $(this).attr("data-stockQuantity");
        var ColorName = $(this).attr("data-colorname");
        var ProductAmount = $(this).attr("data-productamount");

        var brandNameGetSepetIcerik = $(this).attr("data-brandNameGetSepetIcerik");

        var CartCatName = $(this).attr("data-catAddedEnteg");
        var ListPosition = $(this).attr("data-listposition");

        var ColorCode = $(this).attr("data-colorcode");
        var ProductCode = $(this).attr("data-productcode");

        var ProductID = $(this).attr("data-productId");
        var SizeName = $(this).attr("data-size");

        var vp = $('.SepetRow');
        var Email = vp.attr('data-userEmail');
        var GSM = vp.attr('data-userGsm');
        var Gender = vp.attr('data-userGender');
        var HashedEmail = vp.attr('data-hashedEmail');
        var HashedGsm = vp.attr('data-hashedGsm');
        var gtagProductUrl = vp.attr('data-producturl');
        var location1 = window.location.href;

        var AddToCartId = ProductCode + "-R" + ColorCode;

        //remove_from_cart
        dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
        dataLayer.push({
            event: "ecom_event",
            event_category: "ecommerce",
            event_action: "remove_from_cart",
            ecommerce: {
                items: [{
                    item_id: AddToCartId, //Type: String
                    item_group_id: ProductCode, //Type: String
                    item_name: ProductName, //Type: String
                    currency: "TRY", //Type: String
                    discount: null, //Type: Float
                    index: parseInt(ListPosition), //Type: Integer, Desciption: Position in the list
                    item_brand: "BSL", //Type: String
                    item_category: CartCatName, //Type: String, Description: Main category of the product
                    item_category2: null, //Type: String, Description: Type of the product
                    item_list_id: null, //Type: String
                    item_list_name: CartCatName, //Type: String
                    item_variant: SizeName, //Type: String, Description: Size
                    item_size: SizeName, //Type: String
                    item_color: ColorName, //Type: String
                    price: parseFloat(ProductAmount), //Type: Float
                    quantity: 1, //Type: Integer
                    stock: parseInt(stockQuantity)
                }]
            }
        });

        RemoveFromCart(ItemID, LangID);
    });
    // #endregion

    $('#sepetRemoveFromCart').click(function () {

        var temp = $('.OrderBasketContainer .SepetRow .ItemDelete .RemoveIcon');

        var ProductName = temp.attr("data-productname");

        var ProductQuantity = temp.attr("data-quantity");

        var stockQuantity = temp.attr("data-stockQuantity");
        var ColorName = temp.attr("data-colorname");
        var ProductAmount = temp.attr("data-productamount");

        var brandNameGetSepetIcerik = temp.attr("data-brandNameGetSepetIcerik");

        var CartCatName = temp.attr("data-catAddedEnteg");
        var ListPosition = temp.attr("data-listposition");

        var ColorCode = temp.attr("data-colorcode");
        var ProductCode = temp.attr("data-productcode");

        var ProductID = temp.attr("data-productId");
        var SizeName = temp.attr("data-size");

        var AddToCartId = ProductCode + "-R" + ColorCode;

        //alert(AddToCartId);

        //remove_from_cart
        dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
        dataLayer.push({
            event: "ecom_event",
            event_category: "ecommerce",
            event_action: "remove_from_cart",
            ecommerce: {
                items: [{
                    item_id: AddToCartId, //Type: String
                    item_group_id: ProductCode, //Type: String
                    item_name: ProductName, //Type: String
                    currency: "TRY", //Type: String
                    discount: null, //Type: Float
                    index: parseInt(ListPosition), //Type: Integer, Desciption: Position in the list
                    item_brand: "BSL", //Type: String
                    item_category: CartCatName, //Type: String, Description: Main category of the product
                    item_category2: null, //Type: String, Description: Type of the product
                    item_list_id: null, //Type: String
                    item_list_name: CartCatName, //Type: String
                    item_variant: SizeName, //Type: String, Description: Size
                    item_size: SizeName, //Type: String
                    item_color: ColorName, //Type: String
                    price: parseFloat(ProductAmount), //Type: Float
                    quantity: 1, //Type: Integer
                    stock: parseInt(stockQuantity)
                }]
            }
        });

    });

    $(document).on("change", ".GiftArea #GiftPackageChk", function () {
        var wantGift = $(this).prop("checked");

        SetGift(wantGift, function (status) {
            if (status) {
                $(".OrderContentDetails .GiftAndNoteContainer #OrderGiftNoteText").show();
            }
            else {
                $(".OrderContentDetails .GiftAndNoteContainer #OrderGiftNoteText").hide();
                $(".OrderContentDetails .GiftAndNoteContainer #OrderGiftNoteText").val("");
            }
        });
    });

    // #region Coupon
    $(document).on("change", ".CouponContainer .CouponCodeListArea .myCoupons .custom-select", function () {

        var CouponCode = $(this).parent().find("option:selected").attr("data-code");

        if (CouponCode != null && CouponCode != "" && CouponCode != undefined && CouponCode != "0") {
            UseUserCoupon(CouponCode);
        }
        else {
            RefreshOrderSummary();
            SwalGenerate("warning", "Lütfen kupon seçiniz.", "İşlem Başarısız", "Kapat");
        }
    });

    $(document).on("click", ".SummaryContainer .SummaryBody .DeleteCoupon", function () {
        DeleteUserCoupon();
    });

    $(document).on("click", ".CouponContainer .OrderCouponCodes #UseCoupon", function () {
        CouponCode = $(".CouponContainer #CouponCodeInput").val();

        if (CouponCode != null && CouponCode != "" && CouponCode != undefined) {
            UseUserCoupon(CouponCode);
        }
        else {
            SwalGenerate("warning", "Lütfen kupon kodunuzu giriniz.", "İşlem Başarısız", "Kapat");
        }
    });
    // #endregion
}

function LoginRegisterModalEvents() {
    $('#LoginRegisterModal').on('hide.bs.modal', function () {
        $("#LoginRegisterModal .LoginForm").trigger("reset");
        $("#LoginRegisterModal .RegisterForm").trigger("reset");
        $("#LoginRegisterModal .ForgettenForm").trigger("reset");
        $("#LoginRegisterModal .ConfirmCodePanel").trigger("reset");
        $("#LoginRegisterModal .RegisterPanel").hide();
    });

    $(document).on("click", "#CheckoutHeader .Popup, .OrderContentDetails .RegisterForCoupon .LoginRegister", function (e) {
        var event = $(this).attr("data-event");

        if (event == "login") {
            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ConfirmCodePanel").hide();
        }
        else if (event == "register") {
            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").show();
            $("#LoginRegisterModal .ConfirmCodePanel").hide();
        }

        return false;
    });

    $(document).on("click", "#LoginRegisterModal .NowRegister, #LoginRegisterModal .OpenLoginPanel, #LoginRegisterModal .ForgetPass, #LoginRegisterModal .CancelForgettenPass", function (e) {
        var event = $(this).attr("data-event");

        if ($(this).hasClass("NowRegister")) {
            $("#LoginRegisterModal .RegisterPanel").show();
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
            $("#LoginRegisterModal .ConfirmCodePanel").hide();
        }
        else if ($(this).hasClass("OpenLoginPanel") || $(this).hasClass("CancelForgettenPass")) {
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
            $("#LoginRegisterModal .ConfirmCodePanel").hide();
        }
        else {
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ConfirmCodePanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").show();
        }

        return false;
    });

    $(document).on("click", ".ContinueWithoutMember", function (e) {
        SetMemberless();
    });

    $(document).on("submit", "#LoginRegisterModal form.LoginForm, #LoginRegisterModal form.RegisterForm, #LoginRegisterModal form.ForgettenForm", function () {
        LoginRegisterFormSubmit($(this));

        return false;
    });

    $(document).on("keyup", "#LoginRegisterModal form.RegisterForm input[name='register.UserName']", function () {
        var thisValue = $(this).val();

        thisValue = thisValue.replaceAll(" ", "");
        thisValue = thisValue.toLowerCase();
        thisValue = thisValue.turkishtoEnglish();

        $(this).val(thisValue);
    });
}

function AddressWrapperCountryCahnge(_seciliItemID) {

    console.log("change event for ddl_ulke");

    AddressModal = $(".address-wrapper");
    //var _seciliItemID = $(this).val();

    if (_seciliItemID != undefined && _seciliItemID != "" && _seciliItemID != undefined) {
        GetCities(_seciliItemID); // Ülke değişince şehir listesinin yenilenmesi için çağırılıtyor
    }
    else {
        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        $('.address-wrapper .ddl_sehir option:gt(0)').remove();
    }
}

function AddressWrapperCityCahnge(_seciliItemID) {
    
    console.log("change event for ddl_sehir");

    AddressModal = $(".address-wrapper");
    //var _seciliItemID = $(this).val();

    if (_seciliItemID != undefined && _seciliItemID != "" && _seciliItemID != undefined) {
        GetDistrict(_seciliItemID); // Şehir değişince ilçe listesinin yenilenmesi için çağırılıtyor
    }
    else {
        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        $('.address-wrapper .ddl_ilce option:gt(0)').remove();
    }
}

function AddressWrapperTownCahnge(_seciliItemID) {

    console.log("change event for ddl_ilce");

    AddressModal = $(".address-wrapper");
    //var _seciliItemID = $(this).val();

    if (_seciliItemID != undefined && _seciliItemID != "" && _seciliItemID != undefined) {
        GetQuarters(_seciliItemID); //ilçe değişince mahalle listesinin yenilenmesi için çağırılıtyor
    }
    else {
        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        $('.address-wrapper .ddl_mahalle option:gt(0)').remove();
    }
}

function AddressPageEvents() {
    //if ($("#CurStep").val() == "Adres") {
    //    SetCargoPrice();
    //}

    $(document).on("click", ".AdresTitle", function () {
        $(".address-wrapper .address-body").html("");
        $(".DeliveryAddress").removeClass("d-none");
        $(".SelectAddresTypeCheck").removeClass("d-none");
        $("#OrderSummary").removeClass("d-none");
        $(".AdresTitle").addClass("selected");
        $(".NewAddress").removeClass("selected");
    });

    $(document).on("click", ".sepetOzetButon", function () {
        $(".SummaryBox").toggleClass("open");
    });

    $(document).on("change", ".OrderContentDetails .SelectAddresTypeCheck .CustomCheckbox input[type='radio']", function () {
        if ($(this).prop("checked") == true) {
            $(".BillingAddress").addClass("d-none");

            var setID = $(".OrderContentDetails .DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected .checkable").attr("data-id");
            SetAddress(setID, "Delivery", true);
        }
        else {
            $(".BillingAddress").removeClass("d-none");
        }
    });

    $(document).on("click", ".OrderContentDetails .CheckoutAddressContainer .CustomCheckbox .checkable", function () {
        var id = $(this).attr("data-id");
        var type = "Delivery";
        var typeClass = ".DeliveryAddress";

        if ($(this).closest(".BillingAddress").length > 0) {
            type = "Billing";
            typeClass = ".BillingAddress";
        }

        var isAllSelected = $(".OrderContentDetails .SelectAddresTypeCheck .CustomCheckbox").hasClass("selected");

        if (isAllSelected) {
            $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected").addClass("oldSelect")
            
            $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected input").prop("checked", false);
            $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected label").removeClass("c_on");
            $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected").removeClass("selected");
        }
        else {
            $(typeClass + " .CheckoutAddressContainer .CustomCheckbox").removeClass("selected");
            $(typeClass + " .CheckoutAddressContainer .CustomCheckbox input").prop("checked", false);
            $(typeClass + " .CheckoutAddressContainer .CustomCheckbox label").removeClass("c_on");
        }

        SetAddress(id, type, isAllSelected);
    });

    $(document).on("click", ".CheckoutAddressContainer .NewAddress", function () {
        GetPartialAdress($(".address-wrapper"));
        $("#OrderSummary").addClass("d-none");
        $(".NewAddress").addClass("selected");
        $(".AdresTitle").removeClass("selected");

    });

    $(document).on("click", ".CheckoutAddressContainer .AddressBox .AddressOperation .AddressEdit", function () {
        var AddressModal = $(".address-wrapper");
        var id = $(this).attr("data-id");

        if (id != undefined && id != "" && id > 0) {
            var EditUrl = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/EditOrCreate?id=" + id;

            $("#OrderSummary").addClass("d-none");

            GetPartialAdress(AddressModal, EditUrl);
        }
        else {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });

    $(document).on("click", ".CheckoutAddressContainer .AddressBox .AddressOperation .AddressDelete", function () {
        var id = $(this).attr("data-id");

        if (id != undefined && id != "" && id > 0) {
            DeleteAddress(id);
        }
        else {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });

    $(document).on("click", "#CargoTable tbody tr", function () {
        var CargoPriceID = $(this).find(".OrderRadio input").val();

        if (CargoPriceID != null && CargoPriceID != "" && CargoPriceID != undefined && CargoPriceID > 0) {
            SetCargoPrice(CargoPriceID);
        }
    });

    $(document).on("keyup", ".address-wrapper #Phone2", function (e) {
        if (e.key === " ") {
            $(".address-wrapper #Phone2").val("");
            SwalGenerate("warning", "Telefon numaranızı girerken lütfen sadece rakamları kullanınız.", "Geçersiz GSM Formatı", "Kapat");
        }
    });

    $(document).on("click", ".address-wrapper .FormButtons .btn-cancel", function () {
        $(".AdresTitle").trigger("click");
    });

    $(document).on("change", ".address-wrapper .ddl_ulke", function () {

        console.log("change event for ddl_ulke");

        var _seciliItemID = $(this).val();
        AddressWrapperCountryCahnge(_seciliItemID);

        //AddressModal = $(".address-wrapper");

        //if (_seciliItemID != undefined && _seciliItemID != "" && _seciliItemID != undefined) {
        //    GetCities(_seciliItemID); // Ülke değişince şehir listesinin yenilenmesi için çağırılıtyor
        //    $('.address-wrapper .ddl_sehir').trigger('change'); // İlçelerin boş gelmemesi için tetikleniyor
        //}
        //else {
        //    GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        //    $('.address-wrapper .ddl_sehir option:gt(0)').remove();
        //}
    });

    $(document).on("change", ".address-wrapper .ddl_sehir", function () {

        console.log("change event for ddl_sehir");

        var _seciliItemID = $(this).val();
        AddressWrapperCityCahnge(_seciliItemID);

        //AddressModal = $(".address-wrapper");

        //if (_seciliItemID != undefined && _seciliItemID != "" && _seciliItemID != undefined) {
        //    GetDistrict(_seciliItemID); // Şehir değişince ilçe listesinin yenilenmesi için çağırılıtyor
        //}
        //else {
        //    GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        //    $('.address-wrapper .ddl_ilce option:gt(0)').remove();
        //}
    });

    $(document).on("change", ".address-wrapper .ddl_ilce", function () {

        console.log("change event for ddl_sehir");

        var _seciliItemID = $(this).val();
        AddressWrapperTownCahnge(_seciliItemID);
    });

    $(document).on("submit", ".address-wrapper form.OrderAdressForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        AddAddress(form);

        return false;
    });

    $(document).on("change", ".adrestipradio", function () {
        if ($("#AdresTipi2").is(":checked")) {
            $(".vergi").show("slow");
        }
        else {
            $(".vergi").hide("slow");
        }
    });

    $(document).on("click", "#PaymentAccordion .PaymentTitle", function () {
        $(".PaymentTitle").removeClass("opened");

        var openedItem = $(this);
        $(openedItem).addClass("opened");
    });

    if ($(".MyAddress.DeliveryAddress").length > 0 && $(".MyAddress.DeliveryAddress .CheckoutAddressContainer").length == 0) {
        $(".CheckoutAddressContainer .NewAddress").trigger("click");
    }
}

function PaymentPageEvents() {
    // #region Agreement
    ModalHideEvent($('#AgreementModal'), ".modal-body");

    $(document).on("click", "#OrderSummary .SummaryAgrement .CustomCheckbox .checkable", function () {
        var checked = $("#OrderSummary .SummaryAgrement .CustomCheckbox > input[type='checkbox']").prop("checked");

        SetAgreement(!checked);
    });

    $(document).on("click", "#OrderSummary .SummaryAgrement .CustomCheckbox .checkText a", function () {
        $(".OrderContentDetails #Agreement").clone().appendTo("#AgreementModal .modal-body");
        $("#AgreementModal .modal-body #Agreement").show();
        $("#AgreementModal").modal("show");
    });

    $(document).on("click", "#AgreementModal .modal-footer .btn-ok", function () {
        SetAgreement(true);
        $("#AgreementModal").modal("hide");
    });
    // #endregion

    PaymentButtonControl();

    $lastSelectedBankID = "";
    $lastSelectedDoorID = "";
    $lastSelectedPosID = "";

    firstBin = "";
    lastBin = "";

    // #region Payment Accordion Events
    $('#PaymentAccordion').on('shown.bs.collapse', function () {
        selectedGroup = $(this).find(".panel-collapse.show").parent();

        var webposinstallmentid = selectedGroup.find(".PaymentTitle").attr("data-webposinstallment-id");
        var bankid = selectedGroup.find(".PaymentTitle").attr("data-bankid");

        SetPaymentType(webposinstallmentid, bankid);
    });

    $('#PaymentAccordion').on('show.bs.collapse', function (e) {
        selectedGroup = $(document).find("[data-target='#" + $(e.target).attr('id') + "']").parents(".accordion-item");

        // #region Default Select
        // Girogate Input Seçili Gelmesi
        selectedGroup.find(".GirogateOdemeTuru").first().prop("checked", true);
        // END Girogate Input Seçili Gelmesi

        // Kapıda Ödeme Input Seçili Gelmesi        
        selectedGroup.find(".KapidaOdemeTuru").first().prop("checked", true);
        $lastSelectedDoorID = selectedGroup.find(".KapidaOdemeTuru").first().attr("data-webposinstallment-id");
        // END Kapıda Ödeme Input Seçili Gelmesi

        // Havale Input Seçili Gelmesi        
        selectedGroup.find(".BankID").first().prop("checked", true);
        $lastSelectedBankID = selectedGroup.find(".BankID").first().attr("data-webposinstallment-id");
        // END Havale Input Seçili Gelmesi

        // Web Pos Input Secili Gelmesi

        // Web Pos Input Secili Gelmesi
        selectedGroup.find(".WebPosItem.DefaultPos .WebPosItemInput").first().prop("checked", true);
        $lastSelectedPosID = selectedGroup.find(".WebPosItem.DefaultPos .WebPosItemInput").first().attr("data-webposinstallment-id");
        //$("#CardForm").trigger("reset");

        // #endregion
    });

    $("#PaymentAccordion").on("hidden.bs.collapse", function () {
        PaymentButtonControl();
    });
    // #endregion

    // #region Credit/Debit Card
    $(document).on("click", ".accordion-item .OnlinePos .Installments table tbody tr", function () {
        Input = $(this).find("input[type='radio']");

        var WebPosInsID = Input.attr("data-webposinstallment-id");

        if (WebPosInsID != null && WebPosInsID != "" && WebPosInsID != undefined && WebPosInsID > 0 && $lastSelectedPosID != WebPosInsID) {
            SetPaymentType(WebPosInsID, 0);

            $lastSelectedPosID = WebPosInsID;
            Input.prop("checked", true);
        }
    });

    if ($("#CardNumbers #CardNumber1").length > 0) {
        document.getElementById("CardNumber1").addEventListener("paste", function (e) {
            setTimeout(function () {
                $("#CardNumber1").trigger("keyup");
            }, 300);

        }, false);
    }

    // paste
    $(document).on("keyup", "#CardNumbers input", function (e) {
        // #region Card Number Format
        var cr_1 = $("#CardNumbers input#CardNumber1").val().replace(/\D/g, '');
        cr_1 = formatCCnumber(cr_1);

        $("#CardNumbers input#CardNumber1").val(cr_1);
        //#endregion

        var cardNumber = cr_1.replace(/\D/g, '');
        isAllValid = false;

        $lastCardType = "";

        var result = $(this).validateCreditCard({
            accept: ['visa', 'visa_electron', 'mastercard', 'amex', 'maestro', 'troy']
        });

        //console.log(result);

        if (result != null && result != undefined /*&& cardNumber.length >= 15*/) {
            if (!result.valid) {
                $("#CardNumbers input").addClass("NotValid");
                $("#CardNumbers .cardType").addClass("NotValid").removeClass("Valid");

                if ($lastCardType != "") {
                    $("#CardNumbers .cardType").removeAttr($lastCardType);
                }

                $("#CardForm .cvc").attr("maxlength", "3");

                if ($(".cvc").val().length > 3) {
                    $(".cvc").val("");
                }

                isAllValid = false;
            }
            else {
                $("#CardNumbers input").removeClass("NotValid");
                $("#CardNumbers .cardType").removeClass("NotValid").addClass("Valid");

                $lastCardType = result.card_type.name;
                $("#CardNumbers .cardType").attr("cart_type", result.card_type.name);

                if (result.card_type.name == "amex") {
                    $("#CardForm .cvc").attr("maxlength", "4");
                }
                else {
                    $("#CardForm .cvc").attr("maxlength", "3");

                    if ($(".cvc").val().length > 3) {
                        $(".cvc").val("");
                    }
                }

                isAllValid = true;
            }
        }
        else {
            $("#CardNumbers input").addClass("NotValid");
            $("#CardNumbers .cardType").addClass("NotValid").removeClass("Valid");

            if ($lastCardType != "") {
                $("#CardNumbers .cardType").removeAttr($lastCardType);
            }

            $("#CardForm .cvc").attr("maxlength", "3");

            if ($(".cvc").val().length > 3) {
                $(".cvc").val("");
            }

            isAllValid = false;
        }

        CheckBinNumber();
        PaymentButtonControl();
    });
    // #endregion

    // #region Money Transfer & Pay At Door
    $(document).on("click", ".accordion-item #BankList .BankItem", function () {
        Input = $(this).find("input[type='radio']");

        var bankID = Input.attr("data-bankid");
        var WebPosInsID = Input.attr("data-webposinstallment-id");

        if ($lastSelectedBankID != WebPosInsID) {
            if (bankID != null && bankID != "" && bankID != undefined && bankID > 0
                && WebPosInsID != null && WebPosInsID != "" && WebPosInsID != undefined && WebPosInsID > 0) {
                SetPaymentType(WebPosInsID, bankID);
            }

            $lastSelectedBankID = WebPosInsID;
            Input.prop("checked", true);
        }
    });

    $(document).on("click", ".accordion-item .PayAtDoorList .DoorItem", function () {
        var id = $(this).find("input[type='radio']").attr("data-webposinstallment-id");

        if ($lastSelectedDoorID != id) {
            SetPayAtDoorType(id);
            $lastSelectedDoorID = id;
        }
    });
    // #endregion

    // #region Iyzico SetCardStorage

    $(document).on("change", "#CardForm #SetCardStorage", function () {

        var checked = $(this).prop("checked");

        SetCardStorage(checked);
    });

    // #endregion

    // #region SetCardTokenToPayment

    $(document).on("change", "#creditcardlist .CardItem", function () {

        $("#CardForm").hide();

        var tokenVal = $(this).val();

        //alert("tokenVal: " + tokenVal);

        SetCardTokenToPayment(tokenVal);

        var binNumber = $(this).attr("data-binNumber");

        //taksit listesi getirir.
        GetCardDetails(binNumber);
    });

    $(document).on("focus click", "#Phone2", function () {
        $(".telephoneCodeInInput").css("display", "block");
        $(".telephoneCodeInInput").css("margin-left", "5px");
        $(".telephoneCodeInInput").css("margin-top", "15.5px");
        $("#Phone2").css("padding-left", "30px");
    });

    $(document).on("focus click", "#register_Gsm", function () {
        $(".telephoneCodeInInput").css("display", "block");
        $("#register_Gsm").css("padding-left", "30px");
    });

    $(document).on("focus click", ".RegisterPhone #register_Gsm", function () {
        $(".telephoneCodeInInput").css("margin-top", "12px");
    });

    $(document).on("change", ".SelectDifferentCart", function () {

        //alert("afsf");

        $("#CardForm").show();

        //$("body").append('<style>.cardType:before{top:45% !important;}</style>');

        //$("body").append('<style>.cardType:after{top:50.5% !important;}</style>');
    });


    // #endregion
}

function SendConfirmCode() {
    $("#ConfirmPhoneBtn").die("click").live("click", function () {
        var userName = $("input[name='register.UserName']").val();
        var name = $("input[name='register.Name']").val();
        var gsm = $("input[name='register.Gsm']").val();
        var password = $("input[name='register.Password']").val();
        //var confimrPassword = $("input[name='register.ConfirmPassword']").val();
        var isAllowKvkk = $("input[name='register.AllowTerms']").is(':checked')

        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/User/PasswordValidator",
            data: 'password=' + encodeURIComponent(password),
            success: function (dt) {

                // console.log("SONUC: " + JSON.stringify(dt));

                if (dt.Sonuc == true) {

                    if (userName != "" && name != "" && gsm != "" && password != "" && isAllowKvkk == true) {
                        if (gsm != "" && gsm != null && gsm != undefined/* && gsm.length == 13*/) {
                            GenerateLocalLoading($("body"), "show");

                            $.ajax({
                                type: "POST",
                                url: "/" + $("#SmallLangCode").val() + "/p/User/SendConfirmCode",
                                data: 'Gsm=' + gsm,
                                success: function (dt) {
                                    if (dt.Sonuc == true) {
                                        if (dt.IslemSonucAciklama === "Telefon numarası zaten onaylı.Doğrulama adımları tamamlanmıştır.İşlemi tamamlayabilirsiniz.") {
                                            // Sistemde telefonu kayıtlı ve onaylı olan kullanıcılar üye kayıdı oluşturmak istediği zaman
                                            $.ajax({
                                                type: "POST",
                                                url: "/" + $("#SmallLangCode").val() + "/p/User/UserAdd",
                                                data: $(".UyeOlModal").serialize(),
                                                success: function (re) {
                                                    if (re.Sonuc == true) {
                                                        if (re.JsonRs == "Redirect") {
                                                            window.location.assign("/tr/p/CheckOut/sepet?rf=sepet");
                                                        }
                                                    } else {
                                                        GenerateLocalLoading($("body"), "hide");
                                                        SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                                                    }
                                                }
                                            });
                                        } else {
                                            GenerateLocalLoading($("body"), "hide");
                                            $("#ConfirmCodeAlert").html(gsm + " Numaralı hatta onay kodu gönderilmiştir.")
                                            $("#ConfirmCodeAlert").addClass("alert-success");
                                            $("#confimCodeModal").modal('show');
                                            $(".UyeOlModal .RegisterPanel").hide();
                                            $(".UyeOlModal .LoginPanel").hide();
                                            $(".UyeOlModal .ForgettenPassPanel").hide();
                                        }
                                    }
                                    else {
                                        SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                                        GenerateLocalLoading($("body"), "hide");
                                    }
                                },
                                error: function () {
                                    SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
                                }
                            });
                        }

                        else {
                            SwalGenerate("error", "Lütfen Telefon numaranızı 10 hane olacak şekilde giriniz.", "İşlem Başarısız", "Tekrar Dene");
                        }
                    } else {

                        SwalGenerate("error", "Lütfen tüm alanları doldurunuz , Kullanım Şartları ve Gizlilik Sözleşmesini onaylayınız.", "İşlem Başarısız", "Tekrar Dene");
                    }
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                    GenerateLocalLoading($("body"), "hide");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    });
}

function PhoneFormatAccount() {
    // Burada seçilmiş olan bölgeye göre telefon için uygulanan maske değişecek
    var selectedLangCode = $("#LangChange option:selected").data("langcode");
    var phoneMask = "999 999 99 99";

    switch (selectedLangCode) {
        case "tr":
            phoneMask = "999 999 99 99";
            break;
        case "az":
            phoneMask = "99 999 9999";
            break;
    }

    $("#localPassVM_User_Gsm").mask(phoneMask, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $(".RegisterPhone input").mask(phoneMask, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $("#register_Gsm").mask(phoneMask, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $("#Phone2").mask(phoneMask, { placeholder: "Telefon" }, {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $('#localPassVM_User_Gsm').keypress(function (e) {
        if (this.value.length == 0 && e.which == 48) {
            $(".help-block").fadeIn('slow').fadeOut('slow');
            return false;
        }
    });

    $('#register_Gsm').keypress(function (e) {
        if (this.value.length == 0 && e.which == 48) {
            $(".help-block").fadeIn('slow').fadeOut('slow');
            return false;
        }
    });

    $('#Phone2').keypress(function (e) {
        if (this.value.length == 0 && e.which == 48) {
            $(".help-block").fadeIn('slow').fadeOut('slow');
            return false;
        }
    });
}

function removeLeadingZero(inputElement) {
    var value = inputElement.value;

    value = value.trim();

    if (value.length > 0 && value.charAt(0) === '0') {
        value = value.slice(1);
    }

    inputElement.value = value;
}

$(document).ready(function () {
    if ($("body").hasClass("CheckOut")) {
        ReloadOnTimeOut();
    }

    document.documentElement.setAttribute("data-browser", navigator.userAgent);

    if ($("#CurStep").length > 0) {
        PrepareAddressAndPayment($("#CurStep").val());
    }

    if ($("#CheckoutMessage").length > 0) {
        SwalGenerate("warning", $("#CheckoutMessage").val(), "İşlem Başarısız", "Kapat");
    }

    $(document).on("click", ".OrderProgress .progressbar li", function () {
        var step = $(this).attr("data-step");

        if (step != null && step != "" && step != undefined) {
            SetStep(step, SetStepHandler);
        }
    });

    $(document).on("click", "#OrderDetailArea #OrderSummary #nextbtn", function () {

        var BeginCheckoutList = [];

        var adim = $(this).attr("data-next");
        var href = $(this).attr("data-href");

        if (href != undefined && href != "") {
            document.location.href = href;
            return;
        }

        var urlIndex = window.location.pathname.lastIndexOf("/"); //sondan / bulunan 
        var url = window.location.pathname.substr(urlIndex + 1);
        var currentURL = window.location.href;

        var UserID = $('#UserID').val();

        // Üyeliksiz sipariş için yanlızca sepet sayfasında Üye Giriş Kayıt Modal çıkması istendiği için burası yazıldı
        if (currentURL.indexOf("sepet") !== -1 && (!UserID || UserID == "0")) {
            $("#LoginRegisterModal").modal("show");
            $("#LoginRegisterModal .LoginPanel").show();

            return;
        }

        if (!UserID || UserID == "0")
            UserID = "unknown";

        var TotalAmount = $('.RemoveIcon').attr('data-totalamount');

        if (url == "sepet") {

            var items = $('.RemoveIcon');

            var uniqueItems = {};

            items.each(function () {

                var temp = $(this);

                var ProductID = temp.attr('data-productid');

                var ProductName = temp.attr('data-productname');
                var SizeName = temp.attr('data-size');
                var ColorName = temp.attr('data-colorname');
                var Amount = temp.attr('data-productamount');

                var Quantity = temp.attr('data-quantity');

                var ListPosition = temp.attr('data-listposition');

                // TO-DO: 
                var stockQuantity = $('.RemoveIcon').attr("data-stockQuantity");

                var DatalayerProductCode = temp.attr('data-productcode');
                var DatalayerColorCode = temp.attr('data-colorcode');

                var AddToCartId = DatalayerProductCode + "-R" + DatalayerColorCode;

                //alert(stockQuantity);

                if (!uniqueItems[AddToCartId]) {
                    uniqueItems[AddToCartId] = true;

                    var BeginCheckoutObject = {
                        item_id: AddToCartId, //Type: String
                        item_group_id: DatalayerProductCode, //Type: String
                        item_name: ProductName, //Type: String
                        currency: "TRY", //Type: String
                        discount: null, //Type: Float
                        index: parseInt(ListPosition), //Type: Integer, Desciption: Position in the list
                        item_brand: "BSL", //Type: String
                        item_category: null, //Type: String, Description: Main category of the product
                        item_category2: null, //Type: String, Description: Type of the product
                        item_list_id: null, //Type: String
                        item_list_name: null, //Type: String
                        item_variant: SizeName, //Type: String, Description: Size
                        item_size: SizeName, //Type: String
                        item_color: ColorName, //Type: String
                        price: parseFloat(Amount), //Type: Float
                        quantity: 1, //Type: Integer
                        stock: parseInt(stockQuantity)
                    };

                    BeginCheckoutList.push(BeginCheckoutObject);

                }

            });

            dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
            dataLayer.push({
                event: "ecom_event",
                event_category: "ecommerce",
                event_action: "begin_checkout",
                ecommerce: {
                    currency: "TRY",
                    value: parseFloat(TotalAmount), //integer total cart value
                    items: BeginCheckoutList
                }
            });

        }

        if ($(".PaymentDetail.OnlinePos").closest("#creditcard").hasClass("show") && adim == "progress") {
            SetCreditCartAndStep(adim);
        }
        else if (adim == "progress" && !$("#PaymentAccordion .accordion-item .panel-collapse").hasClass("show")) {
            SwalGenerate("error", "Alışverişinizi tamamlamak için lütfen ödeme yöntemi seçiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
        else {
            SetStep(adim, SetStepHandler);
        }
    });

    $('#sepetAddToCart').click(function () {

        var temp = $('.RemoveIcon');
        var ProductID = temp.attr('data-productid');
        var ProductName = temp.attr('data-productname');
        var SizeName = temp.attr('data-size');
        var ColorName = temp.attr('data-colorname');
        var Amount = temp.attr('data-productamount');
        var Quantity = temp.attr('data-quantity');
        var ListPosition = temp.attr('data-listposition');

        var DatalayerProductCode = temp.attr('data-productcode');
        var DatalayerColorCode = temp.attr('data-colorcode');

        var AddToCartId = DatalayerProductCode + "-R" + DatalayerColorCode;

        //alert(AddToCartId);

        //sepete ekle gtag
        dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
        dataLayer.push({
            event: "ecom_event",
            event_category: "ecommerce",
            event_action: "add_to_cart",
            ecommerce: {
                items: [{
                    item_id: AddToCartId, //Type: String
                    item_group_id: DatalayerProductCode, //Type: String
                    item_name: ProductName, //Type: String
                    currency: "TRY", //Type: String
                    discount: null, //Type: Float
                    index: parseInt(ListPosition), //Type: Integer, Desciption: Position in the list
                    item_brand: "BSL", //Type: String
                    item_category: null, //Type: String, Description: Main category of the product
                    item_category2: null, //Type: String, Description: Type of the product
                    item_list_id: null, //Type: String
                    item_list_name: null, //Type: String
                    item_variant: SizeName, //Type: String, Description: Size
                    item_size: SizeName, //Type: String
                    item_color: ColorName, //Type: String
                    price: parseFloat(Amount), //Type: Float
                    quantity: 1, //Type: Integer
                    stock: parseInt(Quantity)
                }]
            }
        });

    });

    $(document).on("click", ".CustomCheckbox:not(.noWorking)", function () {
        li = $(this);

        if (li.hasClass("selected")) {
            li.find("input").prop('checked', false);
            li.removeClass("selected");
            li.find("label").removeClass("c_on");
        }
        else {
            li.find("input").prop('checked', true);
            li.addClass("selected");
            li.find("label").addClass("c_on");
        }

        li.find("input").trigger("change");
    });

    BasketPageClickEvents();
    LoginRegisterModalEvents();
    AddressPageEvents();
    PaymentPageEvents();
    SendConfirmCode();
    PhoneFormatAccount();
    // Mobil satın alma butonunun aşağıya sabitlenmesi
    if ($(window).width() < 991) {
        $(window).scrollTop($(window).scrollTop() + 1);
        var deviceHeight = $(window).height();

        $(window).scroll(function () {
            var top = $("#SummaryNextBackButtons").offset().top;

            if (($(window).scrollTop() + deviceHeight) > top) {
                $("#SummaryNextBackButtons .SummaryButtonRow").removeClass("fixed");
                $(".SummaryAgrement").removeClass("fixed");
            }
            else {
                $("#SummaryNextBackButtons .SummaryButtonRow").addClass("fixed");
                $(".SummaryAgrement").addClass("fixed");
            }
        });
    }

    $("#LoginConfirmButton").click(function () {
        var confrimCode = $("#confirmCode").val();
        if (confrimCode == "" && confrimCode == undefined) {

        } else {
            $.ajax({
                type: "POST",
                url: "/" + $("#SmallLangCode").val() + "/p/User/UserAdd",
                data: $(".RegisterForm").serialize() + "&ConfirmCode=" + confrimCode,
                success: function (re) {
                    if (re.Sonuc == true) {
                        if (re.JsonRs == "Redirect") {
                            location.reload();
                        }
                    } else if (re.JsonRs == "FailConfirmCode") {
                        SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                        GenerateLocalLoading($("#LoginRegisterModal"), "hide");

                    }
                    else {
                        SwalGenerate("error", re.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                        $("#LoginRegisterModal .RegisterPanel").show();
                        $("#LoginRegisterModal .ConfirmCodePanel").hide();
                        $("#confirmCode").val("");
                        GenerateLocalLoading($("#LoginRegisterModal"), "hide");

                    }
                }
            });
        }

    });

    if ($('#BasketAdvantageModal').length > 0 && $('body').hasClass("CheckOut")) {

        var pgType = $("#PgType").val();

        if (pgType == "CheckOutSepet") {
            if ($(window).width() < 992) {
                $('#BasketAdvantageModal').modal("show");
            }
            else {
                $("#BasketAdvantageModal").modal({
                    keyboard: false,
                    handleUpdate: false,
                    backdrop: 'static'
                });
            }
        }
    }
});